module.exports = __webpack_public_path__ + "static/media/address_proof_front.642168e6.svg";